import { createRouter, createWebHashHistory } from 'vue-router';
import { useUserStore } from '../stores/user';
import HelloWorld from '../components/HelloWorld.vue';
import Login from '../components/Login.vue';
import Register from '../components/Register.vue';
import LiveDetail from '../components/LiveDetail.vue';
import UserCenter from '../components/UserCenter.vue';
import AnchorHome from '../components/AnchorHome.vue';
import About from '../components/About.vue';
import Broadcaster from '../components/Broadcaster.vue';
import HelpCenter from '../components/HelpCenter.vue';
import LiveSquare from '../components/LiveSquare.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld,
    meta: { requiresAuth: false }
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: About,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresAuth: false }
  },
  {
    path: '/live/:id',
    name: 'LiveDetail',
    component: LiveDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/lives',
    name: 'LiveSquare',
    component: LiveSquare,
    meta: { requiresAuth: false }
  },
  {
    path: '/anchor/:id',
    name: 'AnchorHome',
    component: AnchorHome,
    meta: { requiresAuth: false }
  },
  {
    path: '/room/:id',
    name: 'LiveRoomDetail',
    component: () => import('../components/LiveRoomDetail.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/broadcast',
    name: 'Broadcaster',
    component: Broadcaster,
    meta: { requiresAuth: true }
  },
  {
    path: '/user',
    name: 'UserCenter',
    component: UserCenter,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserCenter,
        meta: { requiresAuth: true }
      },
      {
        path: 'wallet',
        name: 'UserWallet',
        component: UserCenter,
        meta: { requiresAuth: true }
      },
      {
        path: 'messages',
        name: 'UserMessages',
        component: UserCenter,
        meta: { requiresAuth: true }
      }
    ]
  },
  // 以下功能已全部内嵌到个人中心，旧链接统一重定向到对应 tab
  { path: '/user/follow', redirect: { path: '/user', query: { tab: 'follow' } } },
  { path: '/user/history', redirect: { path: '/user', query: { tab: 'history' } } },
  { path: '/user/posts', redirect: { path: '/user', query: { tab: 'posts' } } },
  { path: '/user/noble', redirect: { path: '/user', query: { tab: 'noble' } } },
  { path: '/user/broadcast', redirect: { path: '/user', query: { tab: 'broadcast' } } },
  { path: '/user/violation', redirect: { path: '/user', query: { tab: 'violation' } } },
  { path: '/user/recharge', redirect: { path: '/user', query: { tab: 'recharge' } } },
  { path: '/live', redirect: { path: '/' } },
  { path: '/video/:id', redirect: to => ({ path: `/live/${to.params.id}` }) },
  { path: '/post/:id', redirect: to => ({ path: '/user', query: { tab: 'posts', post: String(to.params.id) } }) },
  { path: '/realname', redirect: { path: '/user', query: { tab: 'realname' } } },
  { path: '/recharge', redirect: { path: '/user', query: { tab: 'recharge' } } },
  {
    path: '/help',
    name: 'HelpCenter',
    component: HelpCenter,
    meta: { requiresAuth: false }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('../components/Agreement.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/download',
    name: 'AppDownload',
    component: () => import('../components/AppDownload.vue'),
    meta: { requiresAuth: false }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore();

  // 首次进入或刷新页面时，从 localStorage 恢复用户信息
  if (!userStore.token) {
    userStore.initUserInfo();
  }

  const isLoggedIn = userStore.token && !userStore.isTokenExpired();

  // token 过期时清除登录态
  if (userStore.token && userStore.isTokenExpired()) {
    userStore.clearUserInfo();
  }

  if (to.meta.requiresAuth && !isLoggedIn) {
    // 登录后跳回原页面
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else if ((to.path === '/login' || to.path === '/register') && isLoggedIn) {
    // 已登录用户访问登录/注册页，跳转首页
    next('/');
  } else {
    next();
  }
});

export default router; 
